import { type DailyScheduleSlotEntity } from "@/modules/boxDashboard/modules/DailySchedule/entities/dailyScheduleSlotEntity"
import type { UserDto } from "@/modules/profile/userProfile/userDto"

export type DailyScheduleSlotModel = {
  id: string
  programName: string | null
  color: string
  timeRange: string
  coachName: string | null
  coachAvatar: UserDto["avatar"] | null
  numberOfTrials: number | null
  numberOfDropIns: number | null
  numberOfActualParticipants: number
  numberOfPendingParticipants: number
  hasWaitlist: boolean
  fillPercentage: number
  isPast: boolean
  opacity: number
}

export function createDailyScheduleSlotModel(slot: DailyScheduleSlotEntity): DailyScheduleSlotModel {
  return {
    id: slot.slotId,
    programName: slot.programName,
    color: slot.color ?? "",
    timeRange: slot.getTimeRange(),
    coachName: slot.getCoachFullName(),
    coachAvatar: slot.assignedStaffMembers?.avatar ?? null,
    numberOfTrials: slot.hasTrials() ? slot.numberOfTrials : null,
    numberOfDropIns: slot.hasDropIns() ? slot.numberOfDropIns : null,
    hasWaitlist: slot.hasWaitlist(),
    numberOfActualParticipants: slot.numberOfActualParticipants ?? 0,
    numberOfPendingParticipants: slot.numberOfPendingParticipants ?? 0,
    fillPercentage: slot.getFillPercentage(),
    isPast: slot.getStatus() === "past",
    opacity: slot.getStatus() === "past" ? 0.5 : 1,
  }
}
